module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_glass_40_ffc73d_1x400.png";